import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        getAll: () => executeCall(() => Axios.get(url, { headers: getHeaders() })),
        view: (id) => executeCall(() => Axios.get(url + `/${id}`, { headers: getHeaders() })),
    };
};


export default crudder;